// extracted by mini-css-extract-plugin
export default {"appSuspense":"AppSuspense_appSuspense__zsEmJ","container":"AppSuspense_container__hleZ7","text":"AppSuspense_text__ptEm3"};